import type {
  AboutContent,
  ChangeAdminPasswordPayload,
  KeysSettings,
  SupportSettings,
  TimezoneSettings,
} from '@/domain/settings/entities/settings.entity'
import type { SettingsRepository } from '@/domain/settings/repositories/settings_repository'
import { SettingsPortalRtkDatasource } from '../datasources/settings_portal_rtk_datasource'
import { SettingsRtkDatasource } from '../datasources/settings_rtk_datasource'

export class SettingsRepositoryImpl implements SettingsRepository {
  constructor(
    private readonly portal: SettingsPortalRtkDatasource = new SettingsPortalRtkDatasource(),
    private readonly auth: SettingsRtkDatasource = new SettingsRtkDatasource()
  ) {}

  getSupport(): Promise<SupportSettings> {
    return this.portal.getSupport()
  }

  saveSupport(payload: SupportSettings): Promise<void> {
    return this.portal.saveSupport(payload)
  }

  getKeys(): Promise<KeysSettings> {
    return this.portal.getKeys()
  }

  saveKeys(payload: KeysSettings): Promise<void> {
    return this.portal.saveKeys(payload)
  }

  getTimezone(): Promise<TimezoneSettings> {
    return this.portal.getTimezone()
  }

  saveTimezone(payload: TimezoneSettings): Promise<void> {
    return this.portal.saveTimezone(payload)
  }

  getAboutContent(): Promise<AboutContent> {
    return this.portal.getAboutContent()
  }

  saveAboutContent(payload: AboutContent): Promise<void> {
    return this.portal.saveAboutContent(payload)
  }

  changePassword(payload: ChangeAdminPasswordPayload): Promise<void> {
    return this.auth.changePassword(payload)
  }
}

export const settingsRepository = new SettingsRepositoryImpl()
